import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useForm, FormProvider } from 'react-hook-form';
import {
  Grid,
  Button
} from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { createComment } from '../../../api/managerialDecision/managerialDecisionComment.api';
import Form from './Form';
import { addAlert } from '../../../actions/alerts.action';

const Create = ({ managerialDecisionId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const form = useForm();
  const queryClient = useQueryClient();

  const createCommentMutation = useMutation(
    async ({ content }) => {
      await createComment({ managerialDecisionId, content });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ 'managerialDecisionComments', managerialDecisionId ]);
        form.reset({ content: '' });
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );
  return (
    <FormProvider { ...form }>
      <form onSubmit={
        form.handleSubmit(values => createCommentMutation.mutate(values))
      }>
        <Grid container direction='column' spacing={ 1 } style={ { marginTop: '20px' } }>
          <Form variant={ 'outlined' }/>
          <Grid item>
            <Button
              variant={ 'outlined' }
              color={ 'primary' }
              type={ 'submit' }
            >
              {t('managerialDecisionComments.form.btn.save')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default Create;